module.exports = __webpack_public_path__ + "static/media/pulverizador.d3d69ead.svg";